import { getCookieValue } from '@helsenorge/framework-utils/cookie';
import { setSharedCookie } from '@helsenorge/framework-utils/shared-cookies';

import {
  COOKIE_EXPIRY_DAYS,
  SUMMARY_DISABLED_COOKIE_VALUE,
  SUMMARY_ENABLED_COOKIE_NAME,
  SUMMARY_ENABLED_COOKIE_VALUE,
} from '~/cmsagent/constants/cookies';

export const resolveInitialSummaryEnabled = (isSummaryAvailable: boolean, isSummaryEnabledByDefault: boolean): boolean => {
  if (!isSummaryAvailable) {
    return false;
  }

  const storedChoice = getCookieValue(SUMMARY_ENABLED_COOKIE_NAME);

  if (storedChoice === SUMMARY_ENABLED_COOKIE_VALUE) {
    return true;
  }

  if (storedChoice === SUMMARY_DISABLED_COOKIE_VALUE) {
    return false;
  }

  return isSummaryEnabledByDefault;
};

/** Skal bare kalles når innbyggeren selv velger. Standardvisning fra CMS skal ikke lagres. */
export const saveSummaryChoice = (isEnabled: boolean): void => {
  setSharedCookie(
    SUMMARY_ENABLED_COOKIE_NAME,
    isEnabled ? SUMMARY_ENABLED_COOKIE_VALUE : SUMMARY_DISABLED_COOKIE_VALUE,
    COOKIE_EXPIRY_DAYS
  );
};
